import { Breadcrumb as AntdBreadcrumb } from "antd";
import { Link } from "react-router-dom";
import React from "react";
import styled from "@emotion/styled";

export type Trail = Array<{ name: string; url: string }>;

const BreadcrumbWrapper = styled("div")`
  text-align: right;
`;

interface BreadcrumbProps {
  trail: Trail;
}

const Breadcrumb: React.SFC<BreadcrumbProps> = (props: BreadcrumbProps) => (
  <BreadcrumbWrapper>
    <AntdBreadcrumb>
      <AntdBreadcrumb.Item>Home</AntdBreadcrumb.Item>
      {props.trail.map((item, index) => (
        <AntdBreadcrumb.Item key={index}>
          {index === props.trail.length - 1 ? (
            item.name
          ) : (
            <Link to={item.url}>{item.name}</Link>
          )}
        </AntdBreadcrumb.Item>
      ))}
    </AntdBreadcrumb>
  </BreadcrumbWrapper>
);

export default Breadcrumb;
